import { queryOptions } from '@tanstack/react-query';
import { getSold, type SoldQueryParams } from '@/actions/sold';
import { getAllPages } from '@/utils/fetch/pagination';

const RESOURCE = 'sold' as const;

const sold = {
  byParams: (params: SoldQueryParams) =>
    queryOptions({
      queryFn: () => getAllPages(getSold, params),
      queryKey: [RESOURCE, 'byParams', params] as const,
    }),
};

export { RESOURCE as SOLD_QUERY_KEY, sold };
